<template>
  <v-container>
    <toolbar mode="prediction" title="Generate" view="list" />
    <v-card flat>
      <prediction 
        :applications="applications" 
        :models="methods" 
        :datasets="datasets" 
        :techniques="techniques" 
        @submitted="onSubmit">
      </prediction>
    </v-card>
  </v-container>
</template>

<script>
import toolbar from "@/components/toolbar"
import prediction from "@/components/Forms/Prediction"
import Applications from "@/api/applications"
import Predictions from "@/api/predictions"
import Methods from "@/api/methods"
import Datasets from "@/api/datasets"
import Techniques from "@/api/techniques"
export default {
  name: "CreatePrediction",
  components: {
    toolbar,
    prediction
  },
  data() {
    return {
      applications: [],
      methods: [],
      datasets: [],
      techniques: [],
    }
  },
  created() {
    Applications.list().then(response => this.applications = response.data)
    Methods.list().then(response => this.methods = response.data)
    Datasets.list().then(response => this.datasets = response.data.results)
    Techniques.list().then(response => this.techniques = response.data)
  },
  methods: {
    onSubmit(prediction) {
      Predictions.create({
        name: prediction.name,
        application: prediction.application,
        methods: prediction.methods,
        dataset: prediction.dataset,
        config: prediction.config,
        owner: this.user.id
      }).then(_ => {
        this.notify('Generating prediction...')
        this.$router.push({ name: "predictionList" })
      })
    }
  }
}
</script>